<template>
  <div :class="`form-group form-group-sm`">
    <label class="label" for="motivo">Motivos</label>
    <multiselect-item
      id="motivo"
      v-model="motivo"
      :custom-label="(option) => `${option.id_motivo} - ${option.descripcion}`"
      :options="motivosOptions"
      placeholder="Seleccione motivo"
      track-by="id_motivo"
      :loading="isLoading"
    >
    </multiselect-item>
  </div>
</template>
<script>
import AdaptarVueModel from "../../../../../Clientes/shared/AdaptarVueModel";
import { get } from "lodash-es";
import axios from "axios";
export default {
  name: "SelectorMotivos",
  props: {
    value: {
      default: null,
    },
  },
  mounted() {
    this.getMotivos().then((resp) => {
      if (!resp.ok) {
        this.$msgBoxOk(resp.message);
      }
    });
  },
  mixins: [AdaptarVueModel],
  data: () => ({
    motivosOptions: [],
    isLoading: true,
  }),
  methods: {
    async getMotivos() {
      this.isLoading = true;
      const resp = await axios.post("/execute", {
        method: "CLI.GetMotivos",
        parameters: [],
      });
      if (resp.data.ok) {
        this.motivosOptions = get(resp, "data.result[0]", []);

        this.adaptarVueModel(this.motivosOptions, "id_motivo");
      }
      this.isLoading = false;
      return resp.data;
    },
  },
  computed: {
    motivo: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
